// Constants
import { GET_MY_TEAM } from '~/data/constants/profile-constants';
import { HIDE_MODAL } from '~/data/constants/modal-constants';

// SERVICES
import ProfileService from '~/data/services/profiles-services';
import TeamService from '~/data/services/team-services';

// HELPERS
import { MY_TEAM_URL } from '~/data/constants/router-constants';

/**
 * Removes a user from a team.
 * Then fetches the my team again, with an update to the store
 * and then closes the modal
 *
 * @export
 * @param {*} userId
 * @returns
 */
export function removeUserFromTeam(userId) {
	return dispatch => {
		TeamService.removeUserFromTeam(userId)
			.then(response => {
				if (response.data && response.status === 200) {
					return ProfileService.getMyTeam();
				}
			})
			.then(response => {
				if (response.data) {
					let data = response.data;
					const maximum = 9;
					/*  The response data must be coherent with the expected data on the My Team page.
              So, altough the members array only displays the list of existing members,
              we must normalize the array to include a maximum of 10 empty placeholders.
          */
					if (data.members.length < maximum) {
						for (let i = data.members.length; i <= maximum; i++) {
							data.members.push({
								id: undefined,
								photoUrl: undefined,
								nick: undefined,
							});
						}
					}

					dispatch(updateStore(data));
				} else {
					console.info('response status: ', response.status);
				}
			})
			.catch(error => {
				console.error(error.stack);
			})
			.finally(() => {
				return dispatch(hideModal());
			});
	};

	function updateStore(myTeam) {
		return {
			type: GET_MY_TEAM,
			myTeam: myTeam,
		};
	}

	function hideModal() {
		return {
			type: HIDE_MODAL,
		};
	}
}

export function transferUserToAnotherTeam(state) {
	if (state) {
		return dispatch => {
			ProfileService.getMyTeam()
				.then(response => {
					if (response.data) {
						let data = response.data;
						const maximum = 9;
						/*  The response data must be coherent with the expected data on the My Team page.
              So, altough the members array only displays the list of existing members,
              we must normalize the array to include a maximum of 10 empty placeholders.
          */
						if (data.members.length < maximum) {
							for (let i = data.members.length; i <= maximum; i++) {
								data.members.push({
									id: undefined,
									photoUrl: undefined,
									nick: undefined,
								});
							}
						}

						dispatch(updateStore(data));
					} else {
						console.info('response status: ', response.status);
					}
				})
				.catch(error => {
					console.error('response error: ', error);
				})
				.finally(() => {
					// debugger;
					window.location.href = `${MY_TEAM_URL}`;
				});
		};
	}

	function updateStore(myTeam) {
		return {
			type: GET_MY_TEAM,
			myTeam: myTeam,
		};
	}
}



// WEBPACK FOOTER //
// ./src/redux/actions/team-actions.jsx